const currencies = [
  { code: 'AFN', nameTranslationKey: 'afn' },
  { code: 'ALL', nameTranslationKey: 'all' },
  { code: 'DZD', nameTranslationKey: 'dzd' },
  { code: 'AOA', nameTranslationKey: 'aoa' },
  { code: 'ARS', nameTranslationKey: 'ars' },
  { code: 'AMD', nameTranslationKey: 'amd' },
  { code: 'AWG', nameTranslationKey: 'awg' },
  { code: 'AUD', nameTranslationKey: 'aud' },
  { code: 'AZN', nameTranslationKey: 'azn' },
  { code: 'BSD', nameTranslationKey: 'bsd' },
  { code: 'BHD', nameTranslationKey: 'bhd' },
  { code: 'BDT', nameTranslationKey: 'bdt' },
  { code: 'BBD', nameTranslationKey: 'bbd' },
  { code: 'LSL', nameTranslationKey: 'lsl' },
  { code: 'BZD', nameTranslationKey: 'bzd' },
  { code: 'BMD', nameTranslationKey: 'bmd' },
  { code: 'BTN', nameTranslationKey: 'btn' },
  { code: 'BOB', nameTranslationKey: 'bob' },
  { code: 'BAM', nameTranslationKey: 'bam' },
  { code: 'BWP', nameTranslationKey: 'bwp' },
  { code: 'BRL', nameTranslationKey: 'brl' },
  { code: 'GBP', nameTranslationKey: 'gbp' },
  { code: 'BND', nameTranslationKey: 'bnd' },
  { code: 'BGN', nameTranslationKey: 'bgn' },
  { code: 'MMK', nameTranslationKey: 'mmk' },
  { code: 'BIF', nameTranslationKey: 'bif' },
  { code: 'XOF', nameTranslationKey: 'xof' },
  { code: 'XPF', nameTranslationKey: 'xpf' },
  { code: 'KHR', nameTranslationKey: 'khr' },
  { code: 'CAD', nameTranslationKey: 'cad' },
  { code: 'CVE', nameTranslationKey: 'cve' },
  { code: 'KYD', nameTranslationKey: 'kyd' },
  { code: 'XAF', nameTranslationKey: 'xaf' },
  { code: 'CLP', nameTranslationKey: 'clp' },
  { code: 'CNY', nameTranslationKey: 'cny' },
  { code: 'COP', nameTranslationKey: 'cop' },
  { code: 'KMF', nameTranslationKey: 'kmf' },
  { code: 'CDF', nameTranslationKey: 'cdf' },
  { code: 'CRC', nameTranslationKey: 'crc' },
  { code: 'CUC', nameTranslationKey: 'cuc' },
  { code: 'CUP', nameTranslationKey: 'cup' },
  { code: 'CZK', nameTranslationKey: 'czk' },
  { code: 'DKK', nameTranslationKey: 'dkk' },
  { code: 'DJF', nameTranslationKey: 'djf' },
  { code: 'DOP', nameTranslationKey: 'dop' },
  { code: 'ANG', nameTranslationKey: 'ang' },
  { code: 'XCD', nameTranslationKey: 'xcd' },
  { code: 'EGP', nameTranslationKey: 'egp' },
  { code: 'ERN', nameTranslationKey: 'ern' },
  { code: 'ETB', nameTranslationKey: 'etb' },
  { code: 'EUR', nameTranslationKey: 'eur' },
  { code: 'FKP', nameTranslationKey: 'fkp' },
  { code: 'FJD', nameTranslationKey: 'fjd' },
  { code: 'GMD', nameTranslationKey: 'gmd' },
  { code: 'GEL', nameTranslationKey: 'gel' },
  { code: 'GHS', nameTranslationKey: 'ghs' },
  { code: 'GIP', nameTranslationKey: 'gip' },
  { code: 'GTQ', nameTranslationKey: 'gtq' },
  { code: 'GNF', nameTranslationKey: 'gnf' },
  { code: 'GYD', nameTranslationKey: 'gyd' },
  { code: 'HUF', nameTranslationKey: 'huf' },
  { code: 'HTG', nameTranslationKey: 'htg' },
  { code: 'HNL', nameTranslationKey: 'hnl' },
  { code: 'HKD', nameTranslationKey: 'hkd' },
  { code: 'ISK', nameTranslationKey: 'isk' },
  { code: 'INR', nameTranslationKey: 'inr' },
  { code: 'IDR', nameTranslationKey: 'idr' },
  { code: 'IRR', nameTranslationKey: 'irr' },
  { code: 'IQD', nameTranslationKey: 'iqd' },
  { code: 'ILS', nameTranslationKey: 'ils' },
  { code: 'JMD', nameTranslationKey: 'jmd' },
  { code: 'JPY', nameTranslationKey: 'jpy' },
  { code: 'JOD', nameTranslationKey: 'jod' },
  { code: 'KZT', nameTranslationKey: 'kzt' },
  { code: 'KES', nameTranslationKey: 'kes' },
  { code: 'KRW', nameTranslationKey: 'krw' },
  { code: 'KWD', nameTranslationKey: 'kwd' },
  { code: 'KGS', nameTranslationKey: 'kgs' },
  { code: 'LAK', nameTranslationKey: 'lak' },
  { code: 'LBP', nameTranslationKey: 'lbp' },
  { code: 'LRD', nameTranslationKey: 'lrd' },
  { code: 'LYD', nameTranslationKey: 'lyd' },
  { code: 'MOP', nameTranslationKey: 'mop' },
  { code: 'MKD', nameTranslationKey: 'mkd' },
  { code: 'MGA', nameTranslationKey: 'mga' },
  { code: 'MVR', nameTranslationKey: 'mvr' },
  { code: 'MWK', nameTranslationKey: 'mwk' },
  { code: 'MYR', nameTranslationKey: 'myr' },
  { code: 'MRO', nameTranslationKey: 'mro' },
  { code: 'MUR', nameTranslationKey: 'mur' },
  { code: 'MXN', nameTranslationKey: 'mxn' },
  { code: 'MDL', nameTranslationKey: 'mdl' },
  { code: 'MNT', nameTranslationKey: 'mnt' },
  { code: 'MAD', nameTranslationKey: 'mad' },
  { code: 'MZN', nameTranslationKey: 'mzn' },
  { code: 'NAD', nameTranslationKey: 'nad' },
  { code: 'NPR', nameTranslationKey: 'npr' },
  { code: 'NZD', nameTranslationKey: 'nzd' },
  { code: 'VUV', nameTranslationKey: 'vuv' },
  { code: 'NIO', nameTranslationKey: 'nio' },
  { code: 'NGN', nameTranslationKey: 'ngn' },
  { code: 'KPW', nameTranslationKey: 'kpw' },
  { code: 'NOK', nameTranslationKey: 'nok' },
  { code: 'OMR', nameTranslationKey: 'omr' },
  { code: 'PKR', nameTranslationKey: 'pkr' },
  { code: 'PAB', nameTranslationKey: 'pab' },
  { code: 'PGK', nameTranslationKey: 'pgk' },
  { code: 'PYG', nameTranslationKey: 'pyg' },
  { code: 'PEN', nameTranslationKey: 'pen' },
  { code: 'PHP', nameTranslationKey: 'php' },
  { code: 'PLN', nameTranslationKey: 'pln' },
  { code: 'QAR', nameTranslationKey: 'qar' },
  { code: 'RON', nameTranslationKey: 'ron' },
  { code: 'RUB', nameTranslationKey: 'rub' },
  { code: 'RWF', nameTranslationKey: 'rwf' },
  { code: 'SHP', nameTranslationKey: 'shp' },
  { code: 'WST', nameTranslationKey: 'wst' },
  { code: 'STD', nameTranslationKey: 'std' },
  { code: 'SAR', nameTranslationKey: 'sar' },
  { code: 'RSD', nameTranslationKey: 'rsd' },
  { code: 'SCR', nameTranslationKey: 'scr' },
  { code: 'SLL', nameTranslationKey: 'sll' },
  { code: 'SGD', nameTranslationKey: 'sgd' },
  { code: 'SBD', nameTranslationKey: 'sbd' },
  { code: 'SOS', nameTranslationKey: 'sos' },
  { code: 'ZAR', nameTranslationKey: 'zar' },
  { code: 'LKR', nameTranslationKey: 'lkr' },
  { code: 'SDG', nameTranslationKey: 'sdg' },
  { code: 'SRD', nameTranslationKey: 'srd' },
  { code: 'SZL', nameTranslationKey: 'szl' },
  { code: 'SEK', nameTranslationKey: 'sek' },
  { code: 'CHF', nameTranslationKey: 'chf' },
  { code: 'SYP', nameTranslationKey: 'syp' },
  { code: 'TWD', nameTranslationKey: 'twd' },
  { code: 'TZS', nameTranslationKey: 'tzs' },
  { code: 'THB', nameTranslationKey: 'thb' },
  { code: 'TOP', nameTranslationKey: 'top' },
  { code: 'TTD', nameTranslationKey: 'ttd' },
  { code: 'TND', nameTranslationKey: 'tnd' },
  { code: 'TRY', nameTranslationKey: 'try' },
  { code: 'TMT', nameTranslationKey: 'tmt' },
  { code: 'UGX', nameTranslationKey: 'ugx' },
  { code: 'UAH', nameTranslationKey: 'uah' },
  { code: 'AED', nameTranslationKey: 'aed' },
  { code: 'USD', nameTranslationKey: 'usd' },
  { code: 'UYU', nameTranslationKey: 'uyu' },
  { code: 'UZS', nameTranslationKey: 'uzs' },
  { code: 'VEF', nameTranslationKey: 'vef' },
  { code: 'VES', nameTranslationKey: 'ves' },
  { code: 'VND', nameTranslationKey: 'vnd' },
  { code: 'YER', nameTranslationKey: 'yer' },
  { code: 'ZMW', nameTranslationKey: 'zmw' },
];

function getAllCurrencies() {
  return currencies;
}

function getCurrencyForCode(code) {
  return getAllCurrencies().find((c) => code.toUpperCase() === c.code);
}

export { getAllCurrencies, getCurrencyForCode };
